import LastWinsApi from 'services/api/LastWinsApi/LastWinsApi'

import { SlotsApi } from 'modules/SlotsRoot/api'

import AltenarApi from './AltenarApi/AltenarApi'
import AuthApi from './AuthApi'
import BetbyApi from './BetbyApi/BetbyApi'
import BonusSystemApi from './BonusSystem/BonusSystem'
import DigitainApi from './DigitainApi/DigitainApi'
import JackpotsApi from './JackpotsApi/JackpotsApi'
import PaymentApi from './PaymentApi/PaymentApi'
import ProfileApi from './ProfileApi/ProfileApi'
import SettingsApi from './SettingsApi/SettingsApi'
import SliderApi from './SliderApi/SliderApi'
import SoftionApi from './SoftionApi'
import UpgamingApi from './UpgamingApi/UpgamingApi'
import WheelGameApi from './WheelGameApi/WheelGameApi'

class Api {
  public auth: AuthApi

  public settings: SettingsApi

  public profile: ProfileApi

  public slots: SlotsApi

  public payment: PaymentApi

  public wheelGame: WheelGameApi

  public bonusSystem: BonusSystemApi

  public softion: SoftionApi

  public upgaming: UpgamingApi

  public jackpots: JackpotsApi

  public slider: SliderApi

  public altenar: AltenarApi

  public digitain: DigitainApi

  public betby: BetbyApi

  public lastWins: LastWinsApi

  constructor(baseUrl = '') {
    this.auth = new AuthApi(baseUrl)
    this.settings = new SettingsApi(baseUrl)
    this.profile = new ProfileApi(baseUrl)
    this.slots = new SlotsApi(baseUrl)
    this.payment = new PaymentApi(baseUrl)
    this.wheelGame = new WheelGameApi(baseUrl)
    this.bonusSystem = new BonusSystemApi(baseUrl)
    this.softion = new SoftionApi(baseUrl)
    this.upgaming = new UpgamingApi(baseUrl)
    this.jackpots = new JackpotsApi(baseUrl)
    this.slider = new SliderApi(baseUrl)
    this.altenar = new AltenarApi(baseUrl)
    this.digitain = new DigitainApi(baseUrl)
    this.betby = new BetbyApi(baseUrl)
    this.lastWins = new LastWinsApi(baseUrl)
  }
}

export default Api
